import axios from 'axios';
import { useEffect, useState } from 'react';

import Modal from 'components/Modal';

let popupRequestPromise;

const getPopupList = () => {
    if (!popupRequestPromise) {
        popupRequestPromise = axios
            .get(global.backingsEndpoint + 'popupControl/getList/')
            .then((response) => (Array.isArray(response.data) ? response.data : []));
    }

    return popupRequestPromise;
};

const getDateTimestamp = (value) => {
    if (!value) return null;

    const timestamp = new Date(value).getTime();
    return Number.isFinite(timestamp) ? timestamp : NaN;
};

const isPopupActive = (popup, now) => {
    if (popup?.isActive !== true) return false;

    const dateFrom = getDateTimestamp(popup.dateFrom);
    const dateTo = getDateTimestamp(popup.dateTo);

    if (Number.isNaN(dateFrom) || Number.isNaN(dateTo)) return false;
    if (dateFrom !== null && now < dateFrom) return false;
    if (dateTo !== null && now > dateTo) return false;

    return true;
};

const getPopupDelay = (value) => {
    const delay = Number(value);

    if (!Number.isFinite(delay)) return 0;

    return Math.min(Math.max(delay, 0), 2147483647);
};

const getPopupLink = (value) => {
    const link = Array.isArray(value) ? value[0] : value;

    if (typeof link !== 'string') return null;

    const normalizedLink = link.trim();

    return /^(https?:\/\/|\/)/i.test(normalizedLink) ? normalizedLink : null;
};

export const getPopupImageUrl = (galleryImage) => {
    const photoKey = galleryImage?.photo;

    if (typeof photoKey !== 'string' || !photoKey.trim()) return null;

    return `${global.backingsEndpoint}photoRepository/getImageBySize?size=ORIGINAL&key=${encodeURIComponent(photoKey.trim())}`;
};

export default function GlobalPopup() {
    const [popupList, setPopupList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        let isMounted = true;

        getPopupList()
            .then((list) => {
                if (!isMounted) return;

                const now = Date.now();
                setPopupList(list.filter((popup) => isPopupActive(popup, now)));
            })
            .catch((error) => {
                console.error('Popup list loading failed:', error);
            });

        return () => {
            isMounted = false;
        };
    }, []);

    const currentPopup = popupList[currentIndex];

    useEffect(() => {
        if (!currentPopup) return undefined;

        const timeoutId = window.setTimeout(() => {
            setIsOpen(true);
        }, getPopupDelay(currentPopup.showTime));

        return () => window.clearTimeout(timeoutId);
    }, [currentPopup]);

    const closePopup = () => {
        setIsOpen(false);
        setCurrentIndex((index) => index + 1);
    };

    if (!currentPopup) return null;

    const link = getPopupLink(currentPopup.link);
    const title = currentPopup.title || currentPopup.name;
    const imageUrl = getPopupImageUrl(currentPopup.galleryImage);

    // currentPopup.content = 'Lorem ipsuim'

    return (
        <Modal
            open={isOpen}
            onClose={closePopup}
            maxWidth="max-w-[520px]"
            className="!w-full !grandient-gray"
        >
            <div className="flex flex-col items-center gap-0">

                {title && (
                    <h2 className="w-full text-left font-display text-3xl sm:text-4xl font-black leading-tight text-white px-6 py-4">
                        {title}
                    </h2>
                )}

                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt={title || currentPopup.galleryImage.name || 'Felugró ablak képe'}
                        className="block max-h-[50dvh] w-full bg-black/10 object-contain"
                    />
                )}

                {currentPopup.content && (
                    <div
                        className="w-full text-left bg-white text-black p-6 rounded-2xl shadow-2xl text-sm leading-relaxed [&_a]:font-semibold [&_a]:text-green-700 [&_a]:underline"
                        dangerouslySetInnerHTML={{ __html: currentPopup.content }}
                    />
                )}

                {currentPopup.buttonTitle && link && (
                    <div className='w-full p-4'>
                        <a
                            href={link}
                            target={link.startsWith('http') ? '_blank' : undefined}
                            rel={link.startsWith('http') ? 'noopener noreferrer' : undefined}
                            onClick={closePopup}
                            className="w-full button gradient-green"
                        >
                            {currentPopup.buttonTitle}
                        </a>
                    </div>
                )}

            </div>
        </Modal>
    );
}
